<template>
  <v-sheet
    color="white"
    elevation="3"
    rounded
  >
    <div class="profile-content">
      <v-row class="ma-0 mb-3">
        <h1 class="mb-4" v-if="showId">Show #{{showId}}</h1>
        <h1 class="mb-4" v-else>New Show</h1>
        <v-spacer />
      </v-row>
      <v-tabs v-model="tab">
        <v-tab key="showId">
          <span v-if="showId">Show Schedule</span>
          <span v-else>Schedule New Show</span>
        </v-tab>
        <v-tab key="showProcessing" v-if="showId">
          Show Processing
        </v-tab>
        <v-tab key="stockdogSummary" v-if="showId && !!showInfo && !['C','R','RT', 'FT', 'A', 'O', 'T','SD','DJ'].includes(showInfo.programType)">
          Stockdog
        </v-tab>
        <v-tab key="ranchSummary" v-if="showId && !!showInfo && showInfo.programType == 'RT'">
          Ranch
        </v-tab>
        <v-tab key="farmSummary" v-if="showId && !!showInfo && showInfo.programType == 'FT'">
          Farm
        </v-tab>
        <v-tab key="showResults" v-if="showId"> Show results </v-tab>
        <v-tab key="conformationSummary" v-if="showId && !!showInfo && !['R','RT', 'FT', 'ST', 'A', 'O', 'T','SD','DJ'].includes(showInfo.programType)">
          Intact/Altered
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="showId">
          <ShowEntry :showId="showId" />
        </v-tab-item>
        <v-tab-item key="showProcessing">
          <ShowProcessing :showId="showId" />
        </v-tab-item>
        <v-tab-item key="stockdogSummary" v-if="!!showInfo && !['C','R','RT', 'FT', 'A', 'O', 'T', 'SD', 'DJ'].includes(showInfo.programType)">
          <StockResultSummaryEntry :showId="showId" :stockResultCategories="stockResultsCategories"/>
        </v-tab-item>
        <v-tab-item key="ranchSummary" v-if="!!showInfo && showInfo.programType == 'RT'">
          <StockResultSummaryEntry :showId="showId" :stockResultCategories="stockResultsCategories" />
        </v-tab-item>
        <v-tab-item key="farmSummary" v-if="!!showInfo && showInfo.programType == 'FT'">
          <StockResultSummaryEntry :showId="showId" :stockResultCategories="stockResultsCategories" />
        </v-tab-item>
        <v-tab-item key="showResults">
          <div v-if="!!showInfo.programType && ['R','RT', 'FT', 'ST', 'A', 'C', 'O', 'T', 'SD', 'DJ'].includes(showInfo.programType)">
            <RallyShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'R'" />
            <RanchTrialShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'RT'" />
            <FarmTrialShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'FT'" />
            <AgilityShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'A'" />
            <ConformationShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'C'" />
            <ObedienceShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'O'" />
            <TrackingShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'T'" />
            <StockdogShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'ST'" />
            <ScentDetectionShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'SD'" />
            <DockJumpingShowResultsEntry :showId="showId" :showInfo="showInfo" v-if="showInfo.programType == 'DJ'" />
          </div>
          <div v-else>
            <DefaultShowResultsEntry :showId="showId" :showInfo="showInfo" />
          </div>
        </v-tab-item>
        <v-tab-item key="conformationSummary" v-if="!!showInfo && !['R','RT', 'FT', 'ST', 'A', 'O', 'T','SD','DJ'].includes(showInfo.programType)">
          <ConformationShowResultsSummaryEntry :showId="showId" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import ShowEntry from "@/components/Admin/Details/Shows/ShowEntry.vue";
import ShowProcessing from "@/components/Admin/Details/Shows/ShowProcessing.vue";
import RallyShowResultsEntry from "@/components/Admin/Details/Shows/RallyShowResultsEntry.vue";
import RanchTrialShowResultsEntry from "@/components/Admin/Details/Shows/RanchTrialShowResultsEntry.vue";
import FarmTrialShowResultsEntry from "@/components/Admin/Details/Shows/FarmTrialShowResultsEntry.vue";
import StockdogShowResultsEntry from "@/components/Admin/Details/Shows/StockdogShowResultsEntry.vue";
import AgilityShowResultsEntry from "@/components/Admin/Details/Shows/AgilityShowResultsEntry.vue";
import ConformationShowResultsEntry from "@/components/Admin/Details/Shows/ConformationShowResultsEntry.vue";
import ObedienceShowResultsEntry from "@/components/Admin/Details/Shows/ObedienceShowResultsEntry.vue";
import TrackingShowResultsEntry from "@/components/Admin/Details/Shows/TrackingShowResultsEntry.vue";    
import DefaultShowResultsEntry from "@/components/Admin/Details/Shows/DefaultShowResultsEntry.vue";
import StockResultSummaryEntry from "@/components/Admin/Details/Shows/StockResultsSummaryEntry.vue";
import ConformationShowResultsSummaryEntry from "@/components/Admin/Details/Shows/ConformationShowResultsSummaryEntry.vue";
import ScentDetectionShowResultsEntry from "@/components/Admin/Details/Shows/ScentDetectionShowResultsEntry.vue";
import DockJumpingShowResultsEntry from "@/components/Admin/Details/Shows/DockJumpingShowResultsEntry.vue";
import showService from "@/services/admin/showService";

export default Vue.extend({
  name: "ShowDetails",
  components: {
    ShowEntry,
    ShowProcessing,
    RallyShowResultsEntry,
    RanchTrialShowResultsEntry,
    FarmTrialShowResultsEntry,
    StockdogShowResultsEntry,
    AgilityShowResultsEntry,
    ConformationShowResultsEntry,
    ObedienceShowResultsEntry,
    TrackingShowResultsEntry,
    DefaultShowResultsEntry,
    StockResultSummaryEntry,
    ConformationShowResultsSummaryEntry,
    ScentDetectionShowResultsEntry,
    DockJumpingShowResultsEntry,
  },
  data: function() {
    return {
      tab: null,
      showDetails: {
        showTypeId: null
      },
      stockResultsCategories: [] as any[],
      showInfo: {
        categories: [],
        divisions: [],
        judges: [],
        allowedDatesFrom: null,
        allowedDatesTo: null,
        programType: null
      },
    };
  },
  methods: {
    reloadData: function() {
      if (this.showId) {

        showService
          .getShowInfoForShowResults(this.showId)
          .then((res) => {
            this.showInfo = res; 
          })
          .catch(this.$handleError);
      }
    },
    reloadStockCategories: function() {
      const forCategories = ['ST', 'RT', 'FT'];
      const defaultCategory = 'ST';

      showService
        .getProgramShowResultCategories(forCategories.includes(this.programType)
          ? this.showInfo.programType as any
          : defaultCategory
        )
        .then((res) => {
          this.stockResultsCategories = res; 
        })
        .catch(this.$handleError);
    }
  },    
  created: function() {
    this.reloadData();
  },
  watch: {
    showId: function(newVal: String) {
      this.reloadData();
    },
    programType: function(newValue: any) {
      this.reloadStockCategories();
    }
  },
  props: {
    showId: { type: String },
  },
  computed: {
    programType: function(): any {
      return this.showInfo.programType;
    }
  },
});
</script>
